export const localPaths = {
    home: '',
    admin: 'admin',
    login: 'login',
    signup: 'signup',
    // where an invitation link lands: /university/<alias>/invitation#token=... (#30)
    invitation: 'invitation',
    // where a distributor invitation lands: /university/distributor-invitation#token=... (#77 P77-2), no school in it
    distributorInvitation: 'distributor-invitation',
    student: 'student',
    teacher: 'teacher',
    notifications: 'notifications',
    editNotification: 'notifications/edit',
    makeClass: 'make-class',
    editClass: 'edit-class',
    profile: 'profile',
    accountSetting: 'account-seeting',
    subscription: 'subscription',
    glossary: 'glossary',
    history: 'history',
};

export const apiPaths = {
    // The one call every school page makes first: alias -> organisation. On the new model and open to
    // guests, because the school's login and sign-up pages need the name and logo before anyone has
    // signed in (mirinae-mono#13).
    getOrgByAlias: '/api/org/by-alias/:alias',
    getMyOrgStanding: '/api/org/:orgId/me',

    // B2B APIs for lessons
    getStudentStats: 'api/lessons/getStudentStats/:userId',
};